import Lottie from 'lottie-react';

import lottiePhq9 from '../jsons/phq9.json';

const LottiePhq9 = props => {
  return <Lottie animationData={lottiePhq9} loop={false} {...props} />;
};

export default LottiePhq9;
